module.exports = __webpack_public_path__ + "img/WS.276cf18e.svg";